export const LIST_TRIP_REQUEST = 'LIST_TRIP_REQUEST'
export const LIST_TRIP_SUCCESS = 'LIST_TRIP_SUCCESS'
export const LIST_TRIP_FAIL = 'LIST_TRIP_FAIL'


export const  DETAIL_TRIP_REQUEST = "DETAIL_TRIP_REQUEST"
export const  DETAIL_TRIP_SUCCESS = "DETAIL_TRIP_SUCCESS"
export const  DETAIL_TRIP_FAIL = "DETAIL_TRIP_FAIL"

export const EXPERIENCE_TRIP_REQUEST = "EXPERIENCE_TRIP_REQUEST"
export const EXPERIENCE_TRIP_SUCCESS = "EXPERIENCE_TRIP_SUCCESS"
export const EXPERIENCE_TRIP_FAIL = "EXPERIENCE_TRIP_FAIL"

export const HOMES_TRIP_REQUEST = "HOMES_TRIP_REQUEST"
export const HOMES_TRIP_SUCCESS = "HOMES_TRIP_SUCCESS"
export const HOMES_TRIP_FAIL = "HOMES_TRIP_FAIL"

